import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/IslamicKnowledgeLeftImg.png";
import rightimg from "../../../assets/IslamicKnowledgeRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import islamicKnowledgeBenefitsImg1 from "../../../assets/islamicKnowledgeBenefitsImg1.png";
import islamicKnowledgeBenefitsImg2 from "../../../assets/islamicKnowledgeBenefitsImg2.png";
import islamicKnowledgeBenefitsImg3 from "../../../assets/islamicKnowledgeBenefitsImg3.png";
import islamicKnowledgeBenefitsImg4 from "../../../assets/islamicKnowledgeBenefitsImg4.png";
import islamicKnowledgeBenefitsImg5 from "../../../assets/islamicKnowledgeBenefitsImg5.png";
import islamicKnowledgeBenefitsImg6 from "../../../assets/islamicKnowledgeBenefitsImg6.png";
import islamicKnowledgeBenefitsImg7 from "../../../assets/islamicKnowledgeBenefitsImg7.png";
import islamicKnowledgeBenefitsImg8 from "../../../assets/islamicKnowledgeBenefitsImg8.png";
import islamicKnowledgeBenefitsImg9 from "../../../assets/islamicKnowledgeBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import islamicKnowledgeFunActivitiesImg1 from "../../../assets/islamicKnowledgeFunActivitiesImg1.png";
import islamicKnowledgeFunActivitiesImg2 from "../../../assets/islamicKnowledgeFunActivitiesImg2.png";
import islamicKnowledgeFunActivitiesImg3 from "../../../assets/islamicKnowledgeFunActivitiesImg3.png";
import islamicKnowledgeFunActivitiesImg4 from "../../../assets/islamicKnowledgeFunActivitiesImg4.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const IslamicKnowledgePortal = () => {
  const islamicKnowledgePage = heroContent.islamicKnowledgePage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "270",
      classes: "135",
      description:
        "Seerat-Leam about Prophet Muhammad's (PBUH)life, teachings, and historical events to apply his example in daily life.",
    },
    {
      title: "Module 2",
      activities: "80",
      classes: "60",
      description:
        "Sunnah-Understand and implement the teachings of the Prophet (PBUH) in worship, behavior, and relationships,",
    },
    {
      title: "Module 3",
      activities: "50",
      classes: "40",
      description:
        "Islamic Values & Manners -Leam core Islamie values and ethical conduct to foster good character and positive interactions.",
    },
    {
      title: "Module 4",
      activities: "120",
      classes: "60",
      description:
        "Stories of Prophets-Explore the moral lessons from the lives of the Prophets in the Quran to inspire faith and resilience.",
    },
    {
      title: "Module 5",
      activities: "200",
      classes: "135",
      description:
        "Islamic History-Discover the achievements of Muslim scholars and historical events to build cultural identity and understanding.",
    },
    {
      title: "Module 6",
      activities: "100's",
      classes: "Ongoing",
      description:
        "Quran Memorization-Memorize Surahs and Duas to strengthen spiritual growth and connection to the Quran.",
    },
  ];

  const benefitsData = [
    {
      title: "Stronger Faith",
      description:
        "Deepen connection with Allah through worship and understanding.",
      icon: islamicKnowledgeBenefitsImg1,
    },
    {
      title: "Moral Excellence",
      description:
        "Develop honesty, kindness, and integrity through Islamic teachings.",
      icon: islamicKnowledgeBenefitsImg2,
    },
    {
      title: "Spiritual Growth",
      description:
        "Encourage mindfulness, patience, and gratitude in daily life.",
      icon: islamicKnowledgeBenefitsImg3,
    },
    {
      title: "Quran Understanding",
      description:
        "Learn the meaning and message of the Quran in an age-appropriate way.",
      icon: islamicKnowledgeBenefitsImg4,
    },
    {
      title: "Following Sunnah",
      description:
        "Practice the Prophet's (PBUH) actions as a model for living.",
      icon: islamicKnowledgeBenefitsImg5,
    },
    {
      title: "Character Building",
      description: "Instill values like respect, humility, and responsibility.",
      icon: islamicKnowledgeBenefitsImg6,
    },
    {
      title: "Islamic Knowledge",
      description:
        "Gain a solid foundation in Seera, Hadith, history, and values.",
      icon: islamicKnowledgeBenefitsImg7,
    },
    {
      title: "Academic Engagement",
      description:
        "Foster curiosity and learning through engaging Islamic content.",
      icon: islamicKnowledgeBenefitsImg8,
    },
    {
      title: "Community Awareness",
      description:
        "Understand the role of Muslims in society and their responsibilities.",
      icon: islamicKnowledgeBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Videos",
      image: islamicKnowledgeFunActivitiesImg1,
    },
    {
      title: "Quizzes",
      image: islamicKnowledgeFunActivitiesImg2,
    },
    {
      title: "Discussions",
      image: islamicKnowledgeFunActivitiesImg3,
    },
    {
      title: "Projects",
      image: islamicKnowledgeFunActivitiesImg4,
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "", // Replace with the actual video URL
  };

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={islamicKnowledgePage.titlePart1}
        description={islamicKnowledgePage.description}
        buttonText={islamicKnowledgePage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From Islamic Knowledge Course"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Islamic Knowledge"
        subTitle="With 40+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default IslamicKnowledgePortal;
